<template lang="pug">
  #user-settings(v-if="$app.user")
    #us-header
      h1.title.is-1 Settings
      button.button(@click="save" v-if="isTouch") Save

    #us-wrap
      #us-avatar-wrap
        img#us-avatar(:src="$app.user.image")

        #us-avatar-info-wrap
          #us-title(v-if="isTouch") Avatar
          //- button#us-upload.button(@click="uploadAvatar") Change photo

      #us-form
        .field
          label.label Name
          .control
            input.input(type="text" v-model.trim="$v.form.fullName.$model" placeholder="Required")
            .help.is-danger(v-if="!$v.form.firstName.required || !$v.form.lastName.required") A full name is required

        .field
          label.label Bio
          .control
          textarea.textarea(v-model.trim="form.bio" rows="3" placeholder="Tell the world about yourself.")

        .field
          label.label Location
          .control
            input.input(type="text" v-model.trim="form.location" placeholder="City, Country")

        .field
          label.label Link
          .control
            input.input(type="text" v-model.trim="form.website" placeholder="Business or personal website…")
            .help.is-danger(v-if="!$v.form.website.url") Not a valid URL

        .field
          label.label Twitter

          label.checkbox
            input(type="checkbox" v-model="form.showTwitter")
            span Show Twitter on my profile

        .field
          label.label Email Digest

          label.checkbox
            input(type="checkbox" v-model="form.emailDigest")
            span Receive email digests

        button.button(@click="save") Save Changes

        hr.my-5

        .field
          h3.title.is-5.has-text-danger Account Deletion
          p.mb-3 Deleting your account will permanently remove all your data from our system. This action cannot be undone.
          button.button.is-danger(@click="showDeleteConfirmation = true") Delete Account

        .modal(:class="{'is-active': showDeleteConfirmation}")
          .modal-background(@click="showDeleteConfirmation = false")
          .modal-card
            header.modal-card-head
              p.modal-card-title Delete Account
              button.delete(@click="showDeleteConfirmation = false" aria-label="close")
            section.modal-card-body
              p Are you sure you want to delete your account? This action cannot be undone.
              p All your data, including profile information, likes, and interactions will be permanently removed.
            footer.modal-card-foot
              button.button.is-danger(@click="deleteAccount") Yes, Delete My Account
              button.button(@click="showDeleteConfirmation = false") Cancel
</template>

<script>
import { required, url } from 'vuelidate/lib/validators'

export default {
  props: {},

  data() {
    return {
      form: {
        fullName: '',
        firstName: '',
        lastName: '',
        bio: '',
        emailDigest: true,
        showTwitter: true,
        website: '',
      },
      isTouch: false,
      showDeleteConfirmation: false,
    }
  },

  validations: {
    form: {
      fullName: {
        required,
      },
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      website: {
        url,
      },
    },
  },

  computed: {},

  watch: {
    '$breakpoint.isTouch': {
      immediate: true,
      handler(value) {
        this.isTouch = value
      },
    },
    '$app.userLoaded': {
      immediate: true,
      handler(value) {
        if (value) {
          Object.assign(this.form, this.$app.user)

          if (this.$app.user.state == 'onboard') {
            this.$notyf.error('Please complete your profile before continuing')
          }
        }
      },
    },
    '$v.form.fullName.$model': {
      immediate: true,
      handler(value) {
        ;[this.form.firstName, this.form.lastName] = value?.split(' ')
      },
    },
  },

  methods: {
    save,
    uploadAvatar,
    deleteAccount,
  },

  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
async function save() {
  this.$v.$touch()

  if (this.$v.$invalid) {
  } else {
    const response = await this.$store.dispatch('currentUser/update', this.form)

    if (response.status == 422) {
      response.data.forEach(errorMessage => {
        if (errorMessage == "Last name can't be blank") {
          errorMessage = 'Name field should contain First and Last name'
        }
        this.$notyf.error(errorMessage)
      })
    } else {
      this.$notyf.success('Settings saved')
    }

    this.form = { ...this.form, ...this.$app.user }
  }
}

function uploadAvatar() {
  this.$notyf.success('Coming Soon!')
}

async function deleteAccount() {
  try {
    await this.$store.dispatch('currentUser/deleteAccount')
    this.$notyf.success('Your account has been deleted')
    this.$router.push('/auth/login')
  } catch (error) {
    this.$notyf.error('Failed to delete account. Please try again.')
  }
  this.showDeleteConfirmation = false
}
</script>
